// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import {useNavigation} from '@react-navigation/native';
import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import Text from '../../../components/Text';
import Navbar from '../../../components/Navbar';
import DateTimeInput from '../../../components/DateTimeInput';
import {initialDateFrameState, initialStorageState} from '../utils';
import {useDispatch, useSelector} from 'react-redux';
import {RootStore} from '../../../redux/store';
import Button from '../../../components/Button';
import TextArea from '../../../components/TextArea';
import Input from '../../../components/Input';
import {styles} from '../../../styles';
import {CreateStorage, UpdateStorage} from '../storagesReducer';
import {RouteProp, useRoute} from '@react-navigation/native';
import {RootStackParamList} from '../../../@types';
import FormContainer from '../../../components/FormContainer';
import {isTablet} from 'react-native-device-info';
import Container from '../../../components/Container';
import Content from '../../../navigation/Content';

const AddStorage: React.FC = () => {
  const storage =
    useRoute<RouteProp<RootStackParamList, 'Add storage'>>().params?.storage;
  const isInEditMode = !!storage;
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const userId = useSelector((state: RootStore) => state.auth.user.id);
  const unitId = useSelector(
    (state: RootStore) => state.units.unitLinks,
  ).find(link => link.isDefault === true)?.unit?.id;
  const [storageState, setStorageState] = useState({
    ...initialStorageState,
    createdLogon: userId,
    lastLogon: userId,
    unitId,
  });
  const [dateFrameState, setDateFrameState] = useState({
    ...initialDateFrameState,
    unitId,
  });
  const [startPickerDateVisible, setStartDatePickerVisible] = useState(false);
  const [endDatePickerVisible, setEndDatePickerVisible] = useState(false);
  const storagesState = useSelector((state: RootStore) => state.storages);
  const [title, setTitle] = useState('Add storage');

  useEffect(() => {
    if (isInEditMode) {
      //@ts-ignore
      setStorageState({...storageState, ...storage});
      setDateFrameState({...storage?.dateFrame, ...dateFrameState});
      setTitle('Edit storage');
    }
  }, []);

  const updateState = (field: string, text: string) =>
    setStorageState({
      ...storageState,
      [field]: text,
    });

  return (
    <Container>
      <Content>
        <Navbar title={title} navigation={navigation} />
        <FormContainer>
          <ScrollView
            style={styles.scrollView}
            showsVerticalScrollIndicator={false}>
            <Text style={[styles.textInputLabel, customStyles.marginTop]}>
              Storage bin
            </Text>
            <Input
              minWidth={300}
              style={customStyles.flex}
              value={storageState.storageBin}
              onChangeText={text => updateState('storageBin', text)}
            />
            <Text style={[styles.textInputLabel, customStyles.marginTop]}>
              Bin location
            </Text>
            <Input
              minWidth={300}
              style={customStyles.flex}
              value={storageState.binLocation}
              onChangeText={text => updateState('binLocation', text)}
            />
            <Text style={[styles.textInputLabel, customStyles.marginTop]}>
              Monthly cost
            </Text>
            <Input
              minWidth={300}
              style={customStyles.flex}
              placeholder="e.g 20"
              value={storageState.monthlyCost.toString()}
              onChangeText={text =>
                setStorageState({
                  ...storageState,
                  monthlyCost: parseInt(text, 10),
                })
              }
              keyboardType="number-pad"
            />
            <DateTimeInput
              label="Start date"
              value={new Date(dateFrameState.startDate)}
              onConfirm={date => {
                setDateFrameState({
                  ...dateFrameState,
                  startDate: new Date(date).toISOString(),
                });
              }}
              mode="date"
            />
            <DateTimeInput
              label="End date"
              value={new Date(dateFrameState.endDate)}
              onConfirm={date => {
                setDateFrameState({
                  ...dateFrameState,
                  endDate: new Date(date).toISOString(),
                });
              }}
              mode="date"
            />
            <Text style={[styles.textInputLabel, customStyles.marginTop]}>
              Description
            </Text>
            <TextArea
              minWidth={300}
              style={customStyles.flex}
              value={storageState.description}
              onChangeText={text =>
                setStorageState({...storageState, description: text})
              }
            />
          </ScrollView>
          <Button
            onPress={() => {
              isInEditMode
                ? dispatch(UpdateStorage(dateFrameState, storageState))
                : dispatch(CreateStorage(dateFrameState, storageState));
            }}
            style={customStyles.button}
            isLoading={storagesState.loading}
            py="4"
            isLoadingText="Submitting ...">
            {isInEditMode ? 'Update ' : 'Save'}
          </Button>
        </FormContainer>
      </Content>
    </Container>
  );
};

const customStyles = StyleSheet.create({
  scrollView: {
    marginHorizontal: 8,
    marginVertical: 16,
  },
  marginTop: {
    marginTop: 16,
    flex: 1,
  },
  flex: {
    flex: 1,
  },
  button: {
    marginHorizontal: 8,
    marginBottom: 24,
  },
});

export default AddStorage;
